export const LexiCoreV2ABI = [
  {
    type: "function",
    name: "askLexi",
    inputs: [
      {
        name: "question",
        type: "string",
        internalType: "string"
      }
    ],
    outputs: [
      {
        name: "answer",
        type: "string",
        internalType: "string"
      },
      {
        name: "confidence",
        type: "uint16",
        internalType: "uint16"
      },
      {
        name: "domainsQueried",
        type: "bytes32[]",
        internalType: "bytes32[]"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    name: "IntelligentQueryProcessed",
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "user",
        type: "address",
        internalType: "address"
      },
      {
        indexed: false,
        name: "question",
        type: "string",
        internalType: "string"
      },
      {
        indexed: false,
        name: "domainsQueried",
        type: "bytes32[]",
        internalType: "bytes32[]"
      },
      {
        indexed: false,
        name: "confidence",
        type: "uint16",
        internalType: "uint16"
      },
      {
        indexed: false,
        name: "gasUsed",
        type: "uint256",
        internalType: "uint256"
      }
    ]
  },
  {
    type: "function",
    name: "getRecentConversations",
    inputs: [
      {
        name: "count",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    outputs: [
      {
        name: "",
        type: "tuple[]",
        internalType: "struct LexiCoreV2.ConversationEntry[]",
        components: [
          {
            name: "user",
            type: "address",
            internalType: "address"
          },
          {
            name: "question",
            type: "string",
            internalType: "string"
          },
          {
            name: "answer",
            type: "string",
            internalType: "string"
          },
          {
            name: "domainsQueried",
            type: "bytes32[]",
            internalType: "bytes32[]"
          },
          {
            name: "timestamp",
            type: "uint32",
            internalType: "uint32"
          },
          {
            name: "confidence",
            type: "uint16",
            internalType: "uint16"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getPerformanceStats",
    inputs: [],
    outputs: [
      {
        name: "total",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "successful",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "successRate",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  }
] as const;

